export const FACIAL_HAIR = [
  'Beard',
  'Chin Curtain',
  'Chin Strap',
  'Clean Shaven',
  'Goatee',
  'Goatee with Mustache',
  'Horshoe Mustache',
  'Long Beard',
  'Mustache',
  'Mutton Chops',
  'Pencil Mustache',
  'Sideburns',
  'Soul Patch',
  'Stubble',
  'Toothbrush Mustache',
  'Willing to Shave?',
];
